// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CheckboxInput_checkboxContainer__pK9Jn"};